import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client } from '../../helper/apiCall';
import ENDPOINTS from '../../constants/endpoints';



export const sendNotification = createAsyncThunk(
    'notification/sendNotification',
    async (notificationData, { rejectWithValue, getState }) => {
        try {
            const response = await client.post(ENDPOINTS.NOTIFICATIONS.SEND, notificationData, {
                token: getState().auth.token
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(error.response?.data || 'Bir hata oluştu');
        }
    }
);


const notificationSlice = createSlice({
    name: 'notification',
    initialState: {
        loading: false,
    },
    reducers: {

    },
    extraReducers: (builder) => {
        builder
            .addCase(sendNotification.pending, (state) => {
                state.loading = true;
            })
            .addCase(sendNotification.fulfilled, (state, action) => {
                state.loading = false;
            })
            .addCase(sendNotification.rejected, (state, action) => {
                state.loading = false;
            })

    }
});

export default notificationSlice.reducer; 